export function createRichTextFromNodes(nodes) {
    // a prototype object is needed to ensure backwards compatibility
    // with mobx lib and how deep objects are observed
    // in this case, we want mobx to treat it as a black box object
    return Object.create({}, { nodes: { enumerable: true, writable: false, configurable: false, value: nodes } });
}
